<div class="asignaciones-notifications">
  <button
    type="button"
    class="btn-notifications"
    (click)="toggle($event)"
    [attr.aria-expanded]="open()"
    aria-label="Notificaciones">
    <mat-icon svgIcon="mat:notifications"></mat-icon>
    <span class="badge" *ngIf="unreadCount() > 0">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
  </button>

  <div class="dropdown" *ngIf="open()">
    <div class="dropdown-header">
      <span class="dropdown-title">Notificaciones</span>
      <button type="button" class="btn-mark-all" *ngIf="unreadCount() > 0" (click)="markAllRead($event)">
        Marcar todas leídas
      </button>
    </div>

    <div class="dropdown-body">
      <p class="dropdown-empty" *ngIf="loading()">Cargando...</p>
      <p class="dropdown-empty" *ngIf="!loading() && !notifications().length">Sin notificaciones</p>

      <button
        type="button"
        class="notif-item"
        *ngFor="let n of notifications()"
        [class.notif-item--unread]="!n.readAt"
        (click)="openNotification(n, $event)">
        <span class="notif-message">{{ n.message }}</span>
        <span class="notif-date">{{ n.createdAt | date: 'd MMM y, h:mm a' }}</span>
      </button>
    </div>
  </div>
</div>
